export default __webpack_public_path__ + "static/media/noa-17.29de9044.jpg";